<template>
  <div class="page-title-area item-bg2 jarallax" data-jarallax="{'speed': 0.3}">
    <div class="container">
      <div class="page-title-content">
        <h2>Blog</h2>
        <p>Our Latest News</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>

</style>